import HandshakeIcon from "@mui/icons-material/Handshake";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";

import { isEligibleForOffPlatformBooking } from "components/Shipper/components/MarkBookedOffPlatformModal";
import { useShipperShipmentPageContext } from "hooks";

interface Props {
  onOpenMarkBookedOffPlatform: VoidFunction;
}

export function MarkBookedOffPlatformMenuOption(props: Props) {
  const { onOpenMarkBookedOffPlatform } = props;
  const { shipment } = useShipperShipmentPageContext();

  if (shipment === undefined || !isEligibleForOffPlatformBooking(shipment)) {
    return null;
  }

  return (
    <ListItem>
      <Tooltip
        followCursor
        title={
          <Typography variant="body1">
            Tell us you booked this shipment with a carrier outside Evotrux.
            Support will record the carrier and the rate for you.
          </Typography>
        }
      >
        <ListItemButton onClick={onOpenMarkBookedOffPlatform}>
          <ListItemIcon>
            <HandshakeIcon />
          </ListItemIcon>
          <ListItemText primary="Mark Booked Off Platform" />
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
}
